import { FormikProps } from 'formik';
import React from 'react';
import { EmptyPlaceholder } from '../../shared/EmptyPlaceholder';
import { Header3 } from '../../shared/Headers';
import { Table, TBody, Td, Th, THead, Tr } from '../../shared/Table';
import { EditDesignBillOfMaterialsFormModel } from '../designs/edit-bill-of-materials/editDesignBillOfMaterialsFormModel';
import { ViewOrEditQuoteBillOfMaterialsFormModel } from '../quotes/view-or-edit-bill-of-materials/viewOrEditQuoteBillOfMaterialsFormModel';
import {
  BillOfMaterialsItemFormModel,
  BillOfMaterialsItemsFieldNames,
  itemIsDesignCharge,
} from './billOfMaterialsItemFormModel';
import { ActionButtonTh, CurrencyTh, DragHandleTh, PartCodeTh, QuantityTh, UnitTh } from './BillOfMaterialsItemsTable';
import { BillOfMaterialsRemovedItemField } from './BillOfMaterialsRemovedItemField';
import { BillOfMaterialsUnitFormModel } from './billOfMaterialsUnitFormModel';
import { BillOfMaterialsPartsById } from './dataForEditBillOfMaterialsForm';
import { flatMap } from 'lodash';

type Props = {
  itemsFieldName: BillOfMaterialsItemsFieldNames;
  units: Array<BillOfMaterialsUnitFormModel>;
  partsById: BillOfMaterialsPartsById;
  setFieldValue: FormikProps<
    EditDesignBillOfMaterialsFormModel | ViewOrEditQuoteBillOfMaterialsFormModel
  >['setFieldValue'];
};

export const BillOfMaterialsRemovedItemsField = ({ itemsFieldName, units, partsById, setFieldValue }: Props) => {
  const restoreItem = (item: BillOfMaterialsItemFormModel, unitIndex: number, itemIndex: number) => {
    setFieldValue(`units.${unitIndex}.${itemsFieldName}.${itemIndex}.isDeleted`, false);
  };

  return (
    <>
      <Header3>Removed from Bill of Materials</Header3>
      <Table>
        <THead>
          <Tr>
            <DragHandleTh />
            <PartCodeTh>Part Code</PartCodeTh>
            <QuantityTh>Quantity</QuantityTh>
            <Th>Description</Th>
            <UnitTh>Unit</UnitTh>
            <CurrencyTh>Cost (£)</CurrencyTh>
            <CurrencyTh>Price (£)</CurrencyTh>
            <ActionButtonTh />
          </Tr>
        </THead>
        <TBody>
          {units.map((unit, unitIndex) =>
            unit[itemsFieldName].map((item, itemIndex) =>
              !item.isDeleted || itemIsDesignCharge(item, partsById) ? null : (
                <BillOfMaterialsRemovedItemField
                  key={`${unitIndex}-${itemIndex}`}
                  item={item}
                  unit={unit}
                  partsById={partsById}
                  restoreItem={() => restoreItem(item, unitIndex, itemIndex)}
                  fieldName={`units.${unitIndex}.${itemsFieldName}.${itemIndex}`}
                />
              ),
            ),
          )}
          {flatMap(units, unit => unit[itemsFieldName]).filter(
            item => item.isDeleted && !itemIsDesignCharge(item, partsById),
          ).length === 0 && (
            <Tr>
              <Td colSpan={8}>
                <EmptyPlaceholder message="No items have been removed from the Bill of Materials." />
              </Td>
            </Tr>
          )}
        </TBody>
      </Table>
    </>
  );
};
